function isGridInput(el) {
  return (
    el instanceof HTMLInputElement &&
    !el.disabled &&
    el.closest('table.data-grid tbody td') &&
    (el.type === 'number' || el.type === 'text')
  );
}

function buildNavMatrix(table) {
  const bodyRows = [...table.querySelectorAll(':scope > tbody > tr')];
  const grid = [];

  bodyRows.forEach((tr, r) => {
    if (!grid[r]) grid[r] = [];
    let c = 0;

    [...tr.cells].forEach((td) => {
      while (grid[r][c]) c += 1;

      const rowspan = td.rowSpan || 1;
      const colspan = td.colSpan || 1;
      const input = td.querySelector('input:not(:disabled)');

      for (let i = 0; i < rowspan; i += 1) {
        for (let j = 0; j < colspan; j += 1) {
          const rr = r + i;
          const cc = c + j;
          if (!grid[rr]) grid[rr] = [];
          if (i === 0 && j === 0) {
            grid[rr][cc] = input ? { input, td } : 'blocked';
          } else {
            grid[rr][cc] = 'blocked';
          }
        }
      }

      c += colspan;
    });
  });

  return grid;
}

function findPosition(grid, input) {
  for (let r = 0; r < grid.length; r += 1) {
    const row = grid[r] || [];
    for (let c = 0; c < row.length; c += 1) {
      if (row[c]?.input === input) return { r, c };
    }
  }
  return null;
}

function focusGridInput(input) {
  input.focus();
  try {
    input.select();
  } catch {
    // type="number" may not support select in every browser
  }
  input.closest('td')?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}

function stepToInput(grid, startR, startC, dr, dc) {
  const maxRows = grid.length;
  let r = startR + dr;
  let c = startC + dc;

  while (r >= 0 && r < maxRows) {
    const maxCols = grid[r]?.length ?? 0;
    while (c >= 0 && c < maxCols) {
      const cell = grid[r][c];
      if (cell?.input) {
        focusGridInput(cell.input);
        return true;
      }
      if (dc === 0) break;
      c += dc;
    }
    if (dc !== 0) break;
    r += dr;
  }

  return false;
}

const ARROW_DELTAS = {
  ArrowUp: { dr: -1, dc: 0 },
  ArrowDown: { dr: 1, dc: 0 },
  ArrowLeft: { dr: 0, dc: -1 },
  ArrowRight: { dr: 0, dc: 1 },
};

export function handleGridArrowNavigation(event) {
  if (!ARROW_DELTAS[event.key]) return false;
  if (!isGridInput(event.target)) return false;

  const table = event.target.closest('table.data-grid');
  if (!table) return false;

  const grid = buildNavMatrix(table);
  const pos = findPosition(grid, event.target);

  event.preventDefault();

  if (!pos) return event.target.type === 'number';

  const { dr, dc } = ARROW_DELTAS[event.key];
  stepToInput(grid, pos.r, pos.c, dr, dc);
  return true;
}

export function isFocusedGridNumberInput(target) {
  return (
    isGridInput(target) &&
    target.type === 'number' &&
    document.activeElement === target
  );
}
